import { assert } from '@deqo/foundation';
import { ComponentTuple } from '../../../concepts/objects';

export const DeqoData = {
    wrap(componentTuples: ComponentTuple | ComponentTuple[]) {
        if (componentTuples[0] === 'ddt:v1.1') return componentTuples;
        if (typeof (componentTuples[0]) === 'string') return DeqoData.wrap([componentTuples as ComponentTuple]);
        return ['ddt:v1.1', ...componentTuples];
    },
    unwrap(wrappedTuples: any[]) {
        assert(Array.isArray(wrappedTuples), 'DeqoData: cannot unwrap non-array');
        assert(wrappedTuples[0] === 'ddt:v1.1', 'DeqoData: invalid tuple header');
        return wrappedTuples.slice(1) as ComponentTuple[];
    },
};

export const DeqoStyleData = {
    is(styleData: string | Record<string, unknown>): boolean {
        if (typeof (styleData) === 'string') return !!styleData.match(/\s*\[\s*"dst:/);
        if (Array.isArray(styleData)) return styleData[0] === 'dst:v1.0';
        return false;
    },
    wrap(styleData: Record<string, any>) {
        if (styleData[0] === 'dst:v1.0') return styleData;
        return ['dst:v1.0', styleData];
    },
    unwrap(wrappedStyleData: unknown) {
        assert(Array.isArray(wrappedStyleData), 'DeqoStyleData: cannot unwrap non-array');
        assert(wrappedStyleData[0] === 'dst:v1.0', 'DeqoStyleData: invalid tuple header');
        return wrappedStyleData[1] as Record<string, any>[];
    },
};
